import classNames from 'classnames';
import { useMemo } from 'react';

import styles from './Input/Input.styles.m.css';

interface IUseInputClassNamesParams {
  isFocused?: boolean;
  isError?: boolean;
  isSuccess?: boolean;
  isDisabled?: boolean;
  isLabel?: boolean;
  isPrefix?: boolean;
  placeholder?: string;
  value?: string | number | readonly string[];
}

interface IInputClassNames {
  containerClassName: string;
  contentClassName: string;
  labelClassName: string;
  messageClassName: string;
  inputClassName: string;
  inputWrapperClassName: string;
  prefixClassName: string;
}

export function useInputClassNames(params: IUseInputClassNamesParams): IInputClassNames {
  const { isFocused, isError, isSuccess, isDisabled, isLabel, isPrefix, placeholder, value } =
    params;

  const isSmallLabel = useMemo(
    () => isLabel && (isFocused || Boolean(placeholder) || Boolean(value)),
    [placeholder, value, isFocused, isLabel, isPrefix]
  );

  const containerClassName = classNames(styles.container, {
    [styles.focused]: isFocused,
    [styles.hasError]: isError,
    [styles.success]: isSuccess,
    [styles.disabled]: isDisabled,
    [styles.withLabel]: isLabel,
    [styles.withPrefix]: isPrefix,
    [styles.smallLabel]: isSmallLabel,
  });

  const contentClassName = styles.content;
  const labelClassName = styles.label;
  const messageClassName = styles.message;
  const inputClassName = styles.input;
  const inputWrapperClassName = styles.inputWrapper;
  const prefixClassName = styles.prefix;

  return {
    containerClassName,
    contentClassName,
    labelClassName,
    messageClassName,
    inputClassName,
    inputWrapperClassName,
    prefixClassName,
  };
}
